module.exports = __webpack_public_path__ + "img/anaerobic-bioreactor-text.b6df1f63.svg";